import React, { Component } from 'react';
import gmcabs from '../../images/GMCabsLogo.png'
import applestore from '../../images/ios.png'
import google from '../../images/android.png'
import '../../stylesheet/faqs.css'

class MobFAQS extends Component {
    render() {
        return (
            <div>
                <div className="row" style={{ padding: "30px" }}>
                    <div className="col-sm-12">
                        <div className="header">
                            <h4>Frequently Asked Questions for your GM Cabs Visa Prepaid Card </h4>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                            What is the GM Cabs Visa Prepaid Card?
                        </div>
                        <div className="faq-answer">
                            The Card is a Visa Prepaid card. It allows you to have the flexibility to use the card wherever Visa cards are accepted including retail stores, online merchants and for use overseas.   Forget about the limitations attached to store vouchers, with the GM Cabs Visa Prepaid Visa Card, you have the greatest gift of all – the world of choice.
                        </div>
                    </div>

                    {/* --------------------------------------------------- */}
                    <div className="col-sm-12">
                        <div className="faq-questions">
                            How do I activate my card?
                        </div>
                        <div className="faq-answer">
                            <p>Once you have received the card, you will need to ACTIVATE the card prior to using it. Activation can be done free of charge online at gmcabscard.com.au or the GM Cabs app, enter your card number and last 4 digits of phone number and follow the prompts to activate and register your card. Or phone 1800 914 332 (call charges apply).</p>
                            <p>To activate your card you will need the 16 digit card number, expiration date and the phone number you provided at card registration. </p>
                            <p>During activation you will be able to set a 4 digit PIN.  You will use this PIN when prompted by a merchant when purchasing goods and when withdrawing funds from the ATM.  </p>
                            <p>You will also set a User ID and Password to access the site once your card is activated.</p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                            I cannot activate my card using my phone number?
                        </div>
                        <div className="faq-answer">
                            You may have provided a home phone number, try using this number.  If you are still having difficulty you will need to contact Customer Service by calling 1800 914 332 (call charges apply) or send a request through the ‘Contact Us’ tab at <a>gmcabscard.com.au</a> or via the GM Cabs app.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                            Downloading & using the Mobile App
                        </div>
                        <div className="faq-answer">
                            You can download the GM Cabs app from the following App stores.
                        <div className="col-sm-12">
                                <div className="row">
                                    <div className="col-sm-1 nopadding"> <img style={{width:"100%"}} src={gmcabs} alt="" /></div>
                                    <div className="col-sm-2" style={{marginLeft:"25px",marginTop:"10px"}}><img style={{width:"100%"}} src={applestore} alt="" /></div>
                                    <div className="col-sm-2" style={{marginTop:"10px"}}><img style={{width:"100%"}} src={google} alt="" /></div>
                                </div>
                                <div className="faq-answer">
                                On the app, you can perform the same function that is available on the website gmcabscard.com.au such as Card Activation, Registration, Transaction History, Print Statement and many more. 
                        </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Who can use the card?
                        </div>
                        <div className="faq-answer">
                        You are required to enter a PIN when using your card. Ensure you keep your PIN safe and don’t tell anyone what it is. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What is the maximum balance allowed on the card?
                        </div>
                        <div className="faq-answer">
                        You have a maximum balance of $25,000. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How much can I spend in one transaction?
                        </div>
                        <div className="faq-answer">
                        If your balance permits, you can use your card for purchasing up to $10,000 in a 24 hour period. Should your purchase be greater than $10,000 you will need to pay the balance by another means.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How much can I withdraw from the ATM at one time?


                        </div>
                        <div className="faq-answer">
                        If your balance permits, you can withdraw up to $2000 in a 24 hour period. Please note some ATM’s may charge a fee. You will be prompted by the ATM operator if they will charge a withdrawal fee. You can cancel the transaction at this point.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How can I check my card balance and my transaction history?


                        </div>
                        <div className="faq-answer">
                        You can check your balance and transaction history at any time, free of charge by visiting <a>gmcabscard.com.au</a>or GM Cabs app.  
                        <p>Merchant’s are unable to advise you on your available balance from their POS system. </p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Does the card have an expiry date? 

                        </div>
                        <div className="faq-answer">
                        Yes. It will expire at the end of the month shown on the front of the card. Visit your local GM Cabs office for a replacement card. Your existing balance can be transferred to your new card.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Can I extend the expiry date of my card?
                        </div>
                        <div className="faq-answer">
                        No, expiry dates cannot be extended. You must ensure you use the balance on your card prior to expiry or get a new card from your local GM Cabs office prior to expiry for a balance transfer.

                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Can the card ever have a negative balance? </div>
                        <div className="faq-answer">
                            Whatever value is left on the card after its expiry will be forfeited. We encourage you to use your card before it expires.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                            Can the card ever have a negative balance?

                    </div>
                        <div className="faq-answer">
                        This should never happen as merchants are obliged to obtain authorisation for every purchase. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How secure is the card? 


                        </div>
                        <div className="faq-answer">
                        Visa prepaid cards should be safeguarded, treated like cash. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What should I do with my card once the amount is fully spent?
                        </div>
                        <div className="faq-answer">
                        Your card is reloadable so ensure you keep your card safe as more credits may be applied as per your GM Cabs driver’s  Terms and Conditions. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What is an iCoupon?
                        </div>
                        <div className="faq-answer">
                        An iCoupon is an electronic coupon that can be attached to your card. These may be issued to you for promotional purposes. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Why do my card transactions get declined?
                        </div>
                        <div className="faq-answer">
                        There are several possibilities: 
                        <ul>
                            <li>your card has not been activated </li>
                            <li>the amount of the purchase exceeds your available balance</li>
                            <li>You are entering an incorrect PIN</li>
                            <li>your card has expired </li>
                            <li>your card has been reported lost or stolen </li>
                            <li>your card has been blocked</li>
                            <li>a previous voided or interrupted transaction may have been authorised, and the reserved funds have not yet been released </li>
                            <li>the signature panel on the back of the card has not been signed </li>
                            <li>your signature on the purchase receipt does not match the signature on the back of the card</li>
                            <li>you have tried to withdraw cash from the ATM machine and your balance is not sufficient to cover both the withdrawal amount and the ATM operator’s fee. </li>
                        </ul>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Do I have to remember a PIN? 
                        </div>
                        <div className="faq-answer">
                        Yes. You will need to use your PIN for all transactions made on the card.  You will set your PIN when you activate your card. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What do I do if I’ve forgotten my PIN?
                        </div>
                        <div className="faq-answer">
                        If you forget your PIN you can contact Customer Service on 1800 914 332 (call charges apply) or through the ‘Contact Us’ tab at gmcabscard.com.au or GM Cabs app. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What happens if I enter an incorrect PIN?
                        </div>
                        <div className="faq-answer">
                        Your transaction will be declined if an incorrect PIN is entered.  If you enter an incorrect PIN three times, your card will be blocked and you will need to contact Customer Service on 1800 914 332 (call charges apply) or through the ‘Contact Us’ tab at gmcabscard.com.au or GM Cabs app to release the card. You will be asked some security questions prior to the card being unblocked.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Are there any transactions for which the card cannot be used?
                        </div>
                        <div className="faq-answer">
                            <p>Your card will be declined for any gambling and casino transactions.</p>
                            <p>You may not be able to use your card for any recurring transactions where monthly or regular instalments are set up to draw down on your balance automatically.</p>
                            <p>You cannot use your card to pay for fuel ‘at the pump’ you will need to go inside and pay at the counter.</p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        If a merchant asks me “Credit, Savings or Credit” how should I answer?
                        </div>
                        <div className="faq-answer">
                        You will always select Credit and enter your 4 digit PIN.   
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What if the value of the purchase I want to make is greater than the value / balance on the card?
                        </div>
                        <div className="faq-answer">
                           <p>If you attempt to pay for a purchase that is greater than your available balance, the transaction will be declined. </p>
                           <p>Please ensure you check your available balance prior to making purchases, the merchant will not be able to advise you of your available balance. </p>
                           <p>If your purchase is greater than the amount available on your card, you can pay the difference by using any other type of legal tender accepted by the merchant.     </p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What if the value of the purchase I want to make is less than the value / balance on the card?
                        </div>
                        <div className="faq-answer">
                        Only the exact value of your purchase will be deducted from the balance on the card, so you can use the card for more purchases later. No change will be given.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How do I use my card at hotels, restaurants or other such service orientated merchants?  
                        </div>
                        <div className="faq-answer">
                        In service-oriented merchants like restaurants and hotels where it is customary to give a tip for excellent service, the merchant factors in another 10% when seeking authorisation to cover a generous tip. This is called a tolerance.
                        <p>For example, if the cost of your meal adds up to $100, the merchant will seek authorisation for $110, which means that if the available balance on your card was $100, it would be declined. </p>
                        <p>You should ensure that your card has a balance which covers that 10% buffer when you are transacting with these sorts of merchants, even if you plan to give a smaller tip. </p>
                        <p>When staying at a hotel or going on a cruise, we recommend using the card to pay at checkout, not when making the reservation or checking in. Why? Because a provision for tips of up to 10% is added and reserved in advance for hotel and cruise ship bookings. Such authorisations can take 30 days to clear.</p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Can I use my card overseas?
                        </div>
                        <div className="faq-answer">
                        Yes you can. Please ensure you know your PIN as some countries will not allow you to sign for purchases. For purchases made outside of New Zealand or in any other currency other than NZD , you will pay foreign exchange fees. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What happens if I need to return an item to the merchant? 
                        </div>
                        <div className="faq-answer">
                        Each merchant has its own policy about accepting returned items. You will need to check with the specific merchant on their return policy. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How does my card work?
                        </div>
                        <div className="faq-answer">
                        You can use your card as many times as you like until either the available balance on the card has been exhausted or your card expires.  The amount of each purchase is automatically deducted from the card’s balance. You can use your Visa Prepaid card at any merchant worldwide that accepts Visa Prepaid cards including online merchants.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Can I transfer funds to a friend’s card?
                        </div>
                        <div className="faq-answer">
                        Yes. So long as the cards are from the same program. You can find accounts to transfer to by clicking on Share Funds tab under ‘Quick Links’ once you have logged into gmcabscard.com.au or the GM Cabs app. You can add friends by searching email, last name or card account number. 
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Can additional funds be added to my card? 
                        </div>
                        <div className="faq-answer">
                        Yes. You can load your own funds to your card through a Direct Entry (DE) from your personal Bank Account. You will be able to view the BSB and Account number of your Prepaid Card to load funds to in your online account or once you have logged in to the App. Use the Pay Anyone feature from your own banking institution online account and transfer funds to your GM Cabs Prepaid Card. Funds will take between 1 – 3 days to be loaded to your prepaid card from your banking institution.

                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        What should I do if my card is lost or stolen or damaged? 
                        </div>
                        <div className="faq-answer">
                        Should your card be lost or stolen, you need to block your card immediately so we can stop any subsequent transactions form being authorised. To do this you can log on to the website gmcabscard.com.au, the GM Cabs App or contact Customer Assistance. 
                        <p>You will need to get a new card from your local GM Cabs office. Any remaining balance from the lost card will be transferred to your new card. </p>
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Do I need to pay a fee for each transaction?
                        </div>
                        <div className="faq-answer">
                        No. Approved transactions do not incur a fee. There are some transactions that do incur fees. Check out the Fees and Charges table below.

                        </div>
                        
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        Key Fees and Charges
                        </div>
                        <div className="faq-answer">
                        Below are the key fees and charges that relate to your card. For a full listing please refer to your Terms and Conditions. Should you have any questions relating to any of the fees outlined below you can contact us through gmcabscard.com.au or GM Cabs App.
                        </div>
                        <div style={{ borderColor: "#333", fontSize: "13px", marginLeft: "16px", marginTop: "15px", marginBottom: "30px" }}>
                        <table className="table table-bordered table-sm">
                            <tbody>
                                <tr><td>Online Balance and Contact Us Enquiries</td>
                                    <td>No Charge</td></tr>
                                <tr><td>IVR Automated Telephone Enquiry</td>
                                    <td>$1.50</td></tr>
                                <tr><td>IVR Live Operator Customer Service Assistance</td>
                                    <td>$3.99</td></tr>
                                <tr><td>Transactions made at Point of Sale</td>
                                    <td>No Charge</td></tr>
                                <tr><td>Declined Transactions</td>
                                    <td>$0.15</td></tr>
                                <tr><td>Transaction Reversal Fee (Returns)</td>
                                    <td>ATM operator fee</td></tr>
                                <tr><td>Foreign Exchange Fee</td>
                                    <td>4.5%</td></tr>
                                <tr><td>Chargebacks</td>
                                    <td>$15.00</td></tr>
                                <tr><td>Card Expiry Fee:  The Available Balance on the Card at the time of its expiry.</td><td>Available Balance at card expiry.</td></tr>
                                
                            </tbody>
                        </table>
                    </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        I have forgotten my User ID or Password – how can I recover these details?
                        </div>
                        <div className="faq-answer">
                            Each merchant has its own policy about accepting returned items. You will need to check with the specific merchant on their return policy. Transaction reversals and product returns will incur a fee of $7.50.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                            What do I do if I’ve forgotten my PIN?
                        </div>
                        <div className="faq-answer">
                        If you cannot remember your User ID or Password, please click on Forgot Your Password or the Forgot your User ID button and follow the prompts. The details will be emailed to you as per the email account on your profile.  Please note your User ID, Password and secret Answer is case sensitive so you need to ensure you enter these details exactly as per your Card registration.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        The system will not accept the password I have created. 
                        </div>
                        <div className="faq-answer">
                        Please ensure you follow the password guidelines.   Example of an acceptable password Abcd1234!<br/>
                        An Upper case letter (A-Z)<br/>
                        A Lower case letter (a-z)<br/>
                        A Number<br/>
                        A Special Character<br/>
                        Do not use White spaces and UserID in Password<br/>

                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        How do I print my Transaction History / Statement?
                        </div>
                        <div className="faq-answer">
                        You can download a copy of your statement in PDF. To do this, login to your account and click on Card Activity, select from the drop down menu the period of the statement you wish to print.
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="faq-questions">
                        My funds are not on my card?
                        </div>
                        <div className="faq-answer">
                        Your funds will be uploaded by 8am each day if they are processed before 4am each day.   If you have processed your payments after 4am your funds will be loaded the next day. If there is a discrepancy with your funds loads, please contact GM Cabs directly on (02) 9667 2028 to enquire about your funds.
                        </div>
                    </div>
                   
                </div>

            </div>
        );
    }
}

export default MobFAQS;


// WEBPACK FOOTER //
// ./src/components/mobilefaqs/mobfaq.jsx